module.exports = __webpack_public_path__ + "static/media/justFriends.8fd75dc7.jpg";